// PR-28: distinguish "network was down / unreachable" errors from app
// errors (4xx, validation, auth). Used by MobileShell.onSendQuickFact to
// decide whether to silently queue (network) or surface as an error toast
// (validation).
//
// Native `fetch` throws `TypeError` with messages like:
//   - Chrome:  "Failed to fetch"
//   - Firefox: "NetworkError when attempting to fetch resource."
//   - Safari:  "The Internet connection appears to be offline." / "Load failed"
// Server-shape errors come back as Response.ok === false and our `j()`
// helper raises `Error(\`${status} ${statusText}: ...\`)`. The unauth path
// throws `Error('UNAUTHORIZED')`. The streamMessage path throws
// `Error(\`stream ${status}: ...\`)`. None of those start with a digit-less
// network signature.

const NETWORK_HINTS = [
  'Failed to fetch',
  'NetworkError',
  'network error',
  'Load failed',
  'Internet connection',
  'connection appears to be offline',
  'TypeError: Failed to fetch',
  'fetch failed',
  'ERR_NETWORK',
  'ERR_INTERNET_DISCONNECTED',
]

export function isNetworkError(err: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    // Definitively offline — treat any error during a send as networky.
    return true
  }
  if (err instanceof TypeError) return true
  const msg = err instanceof Error ? err.message : String(err ?? '')
  return NETWORK_HINTS.some((hint) => msg.includes(hint))
}
